const emails = state => state.emails
const email = state => state.email

export default {
  emails,
  email
};
